/** Types d'actions que peut supporter une notification locale de rappel */
export enum EReminderAlarmActionType {
	reschedule = "reschedule",
	repeat = "repeat",
	rescheduleAndRepeat = "rescheduleAndRepeat"
}
